// extracted by mini-css-extract-plugin
export default {"versionLinked":"linked_links-module__versionLinked--1IqIZ","link":"linked_links-module__link--159pS","noLink":"linked_links-module__noLink--1fQg9"};